import { Breadcrumbs, useTheme } from '@mui/material';
import { CerebroLink, CerebroText } from '../../shared/components';
import {
	DataRoom,
	DataRoomDocument,
	DataRoomFolder,
	DataRoomRepository,
	RepositoryBreadcrumb,
} from '../../shared/models';

import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface FolderBreadcrumbsProps {
	dataRoom: DataRoom | null | undefined;
	repository: DataRoomRepository | null | undefined;
	changeFolder: (folder: DataRoomFolder) => void;
}

export const FolderBreadcrumbs: React.FC<FolderBreadcrumbsProps> = ({ dataRoom, repository, changeFolder }) => {
	const theme = useTheme();

	const buildBreadcrumbElement = (breadcrumb: RepositoryBreadcrumb): JSX.Element => {
		if (breadcrumb.isRoot) {
			return buildRootBreadcrumb(breadcrumb.isActive);
		}

		if (breadcrumb.isActive) {
			return <CerebroText key={breadcrumb.navigationGuid}>{breadcrumb.folderName}</CerebroText>;
		} else {
			const folder = {
				guid: breadcrumb.navigationGuid,
				folderGuid: breadcrumb.navigationGuid,
				name: breadcrumb.folderName,
				isVisibleToAll: true,
				files: [] as DataRoomDocument[],
				folders: [] as DataRoomFolder[],
			} as DataRoomFolder;

			return (
				<CerebroLink variant="link" key={breadcrumb.navigationGuid} onClick={() => changeFolder(folder)}>
					{breadcrumb.folderName}
				</CerebroLink>
			);
		}
	};

	const buildRootBreadcrumb = (isActive: boolean): JSX.Element => {
		if (isActive) {
			return (
				<CerebroText key={dataRoom?.rootDataRoomFolderGuid}>
					<FontAwesomeIcon icon={faHome} color={theme.palette.primary.main} /> Root Folder
				</CerebroText>
			);
		}

		const rootFolder = {
			guid: dataRoom?.rootDataRoomFolderGuid,
			folderGuid: null,
			name: 'Root Folder',
			isVisibleToAll: true,
			files: [] as DataRoomDocument[],
			folders: [] as DataRoomFolder[],
		} as DataRoomFolder;

		return (
			<CerebroLink variant="link" key={dataRoom?.rootDataRoomFolderGuid} onClick={() => changeFolder(rootFolder)}>
				<FontAwesomeIcon icon={faHome} color={theme.palette.primary.main} /> Root Folder
			</CerebroLink>
		);
	};

	if (!dataRoom || !repository) return <></>;

	return (
		<Breadcrumbs>
			{repository?.breadcrumbs.length == 0 && buildRootBreadcrumb(true)}
			{repository?.breadcrumbs.sort((a, b) => b.depth - a.depth).map(crumb => buildBreadcrumbElement(crumb))}
		</Breadcrumbs>
	);
};
